import axios from "../../utils/axios";

export const getRelatedPosts = async ({ id, tags }) => {
  let queryStrings =
    tags?.length > 0
      ? tags?.map((tag) => `tags_like=${tag}`).join("&") +
        `&id_ne=${id}`
      : `&id_ne=${id}`;

  const response = await axios.get(`/blogs?${queryStrings}`);

  return response.data;
};
